<template>
  <div class="wrapper">
    <div class="img_wrapper">
      <img src="../../assets/images/h5/yj01.jpeg">
    </div>
    <div class="questionBox">
      <div class="exam-top">会依照您的选择，匹配「<span>专属助教</span>」</div>
      <div class="question">
        <div class="question-item">
          <div class="item">
            <p class="question-title">1. 您的年龄（适合24岁以上成年人）</p>
            <div class="item-input-cont">
              <label class="label"><input type="radio" v-model="age" value="24-31岁"/> 24-31岁</label>
              <label class="label"><input type="radio" v-model="age" value="31-40岁"/> 31-40岁</label>
              <label class="label"><input type="radio" v-model="age" value="41-50岁"/> 41-50岁</label>
              <label class="label"><input type="radio" v-model="age" value="51-60岁"/> 51-60岁</label>
              <label class="label"><input type="radio" v-model="age" value="60岁以上"/> 60岁以上</label>
              <label class="label"><input type="radio" v-model="age" value="其他"/> 其他</label>
            </div>
          </div>
          <div class="item">
            <p class="question-title">2. 您的职业</p>
            <div class="item-input-cont">
              <label class="label"><input type="radio" v-model="professional" value="普通上班族"/> 普通上班族</label>
              <label class="label"><input type="radio" v-model="professional" value="企业管理层"/> 企业管理层</label>
              <label class="label"><input type="radio" v-model="professional" value="宝妈/宝爸"/> 宝妈/宝爸</label>
              <label class="label"><input type="radio" v-model="professional" value="个体/创业"/> 个体/创业</label>
              <label class="label"><input type="radio" v-model="professional" value="自由工作者"/> 自由工作者</label>
              <label class="label"><input type="radio" v-model="professional" value="离退休人员"/> 离退休人员</label>
              <label class="label"><input type="radio" v-model="professional" value="待业中"/> 待业中</label>
              <label class="label"><input type="radio" v-model="professional" value="其它"/> 其它</label>
            </div>
          </div>
          <div class="item">
            <p class="question-title">3. 您对国学的了解程度</p>
            <div class="item-input-cont">
              <label class="label"><input type="radio" v-model="level" value="从未了解"/> 从未了解</label>
              <label class="label"><input type="radio" v-model="level" value="略知一二"/> 略知一二</label>
              <label class="label"><input type="radio" v-model="level" value="系统学过"/> 系统学过</label>
              <label class="label"><input type="radio" v-model="level" value="熟练应用"/> 熟练应用</label>
            </div>
          </div>
        </div>
      </div>
      <button class="btn" @click="applyClick()" style="color: rgb(255, 255, 255); background-color: rgb(255, 111, 39);">
        立即报名
      </button>
    </div>
    <div class="image-box">
      <img src="../../assets/images/h5/yj02.jpeg">
    </div>
    <p class="company"> 山东依智教育科技有限公司</p>
    <div class="dig-div"></div>
    <div class="pay-box">
      <div class="price-box">
        <p class="price" style="color: rgb(244, 116, 42);">
          <span>仅需</span>¥
        </p>
        <p class="num" style="color: rgb(244, 116, 42);">1</p>
      </div>
      <div class="pay-btn" style="color: rgb(255, 255, 255); background-color: rgb(244, 116, 42); font-size: 16px;"
           @click="applyClick()">
        <span>立即报名</span>
      </div>
    </div>
    <!--弹框-->
    <div class="dig_wrap">
      <mt-popup v-model="popupVisible" position="bottom">
        <p class="close" @click="close()"><img src="../../assets/images/h5/close.jpeg"/></p>
        <div class="dig_box">
          <div class="dig-label">姓名：</div>
          <input label="姓名:" placeholder="请输入您的姓名" type="realName" v-model.trim="realName" class="input"/>
          <div class="dig-label">手机号：</div>
          <input label="手机号:" placeholder="请输入您的手机号" type="tel" v-model.trim="mobile" ref="mobileInput" class="input"/>
          <div class="dig-label">验证码：</div>
          <input label="验证码:" maxlength="4" placeholder="请输入验证码" v-model.trim="refereeName" ref="codeInput"
                 class="refereeName-input">
          <span @click="getCode" class="getCode-btn">{{ verificationCode }}</span></input>
          <div style="text-align: center;margin-top: 30px">
            <button @click="save()" class="apply">立即支付</button>
          </div>
        </div>
      </mt-popup>
    </div>
  </div>

</template>
<script>
import {orderAdd, getConversion, getRegisterCode, getVerifyCode} from "../../apis/apis";
import {Toast, Radio, Popup} from 'mint-ui';
import Vue from 'vue'

Vue.component(Radio.name, Radio);

export default {
  components: {},
  name: "",
  data() {
    return {
      clickid: "",// 获取抖音推广里的clickid关键广告信息
      count: '',
      status: true,
      timer: 60,
      refereeName: "",//获取验证码
      verificationCode: "发送验证码",
      popupVisible: false,
      age: '',
      professional: '',
      level: '',
      mobile: "", //手机号
      realName: "", //姓名
      orderNo: "",
      pageUrl: "",
    }
  },
  methods: {
    //立即报名
    applyClick() {
      if (this.age && this.professional && this.level) {
        this.popupVisible = true;
      } else {
        Toast({
          message: '请填写调查问卷！',
          className: 'notice',
        });
      }
    },
    getCode() {
      if (this.mobile == "") {
        Toast({
          message: '手机号码不能为空！',
          className: 'notice',
        });
      } else {
        this.getRegisterCode();
      }
    },
    async getRegisterCode() { //获取验证码接口
      try {
        let param = {
          "mobile": this.mobile
        }
        let {
          data
        } = await getRegisterCode(param);
        if (data.code == 1000) {
          if (this.status) {
            this.status = false;
            var count = this.timer;
            this.verificationCode = count + "s后重新获取";
            var timer = setInterval(() => {
              if (count === 0) {
                clearInterval(timer);
                this.verificationCode = "获取验证码";
                this.status = true;
              } else {
                count--;
                this.verificationCode = count + "s后重新获取";
              }
            }, 1000);
          }
        } else {
          Toast({
            message: data.message,
            className: 'notice',
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getVerifyCode() { //验证短信验证码是否正确
      try {
        let param = {
          "mobile": this.mobile,
          "mobileCode": this.refereeName,
        }
        // alert(param.mobile)
        // alert(param.mobileCode)
        let {
          data
        } = await getVerifyCode(param);
        // alert(data.code)
        if (data.code == 1000) {
          this.confirmRmbPay();
          this.getConversion() //回传广告
        } else {
          Toast({
            message: data.message,
            className: 'notice',
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    save() {
      if (this.realName == "") {
        Toast({
          message: "请输入您的姓名！",
          className: 'notice',
        });
        return
      }
      if (this.mobile == "") {
        Toast({
          message: "请输入您的电话！",
          className: 'notice',
        });
        return
      }
      this.getVerifyCode();
    },
    close() {
      this.popupVisible = false;
      this.refereeName = "";
    },
// 判断是否在微信浏览器  1为微信浏览器 2为其他  这个方法定义在外面，后面也会用到
    _isweixin() {
      return new Promise((resolve) => {
        const ua = window.navigator.userAgent.toLowerCase();
        //userAgent 属性是一个只读的字符串，声明了浏览器用于 HTTP 请求的用户代理头的值。
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          resolve(1);
        } else {
          resolve(2);
        }
      });
    },
    // 确认人民币付款
    async confirmRmbPay() {
      // alert("=====")
      const isweixin = await this._isweixin();
      if (isweixin === 2) {
        const params = {
          mobile: this.mobile,
          realName: this.realName,
          totalPrice: "1",
          json: JSON.stringify({年龄: this.age, 您的职业: this.professional, 熟悉程度: this.level}),
          paid: true,
          type: 1,
        };
        // alert(params.mobile)
        // alert(params.realName)
        // alert(params.totalPrice)
        // alert(params.json)
        // alert(params.paid)
        // alert(params.type)
        // alert("请在微信以外的浏览器里打开并支付!");
        orderAdd(params).then((res) => {
          // alert(res.data.code)
          if (res.data.code === 200) {
             this.getConversion() //回传广告
            // 调用直接跳转后台返回给你的url地址，类似下面的地址
            this.pageUrl = res.data.data.jsConfig.mwebUrl;
            // alert(this.pageUrl)
            window.location.href = this.pageUrl + '&redirect_url=' + 'https://m.yzvet.com/advertisePage';

          } else {
            Toast({
              message: res.message,
              className: 'notice',
            });
          }
        }).catch((err) => {
          // alert(err)
        });
      } else {
      }
    },
    //获取地址栏参数
    GetQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // https://analytics.oceanengine.com/api/v2/conversion  上传广告回调到抖音
    async getConversion() {
      try {
        let params = {
          "event_type": "form",
          "context": {
            "ad": {
              "callback": this.clickid,//callback 这里需要填写的就是从启动参数里获取的 clickid
            }

          },
          "timestamp": new Date().valueOf(),
        }
        let {
          data
        } = await getConversion(params);
        if (data.code == 0) {
          Toast({
            message: "上传成功",
            className: 'notice',
          });
        } else {
          // Toast({
          //   message: data.message,
          //   className: 'notice',
          // });
          // alert(data.message)
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.GetQueryString();
    let myurl = this.GetQueryString("clickid");
    if (myurl != null && myurl.toString().length > 1) {
      this.clickid = (this.GetQueryString("clickid"));
    }
  }
}
</script>
<style scoped>
.questionBox {
  padding-bottom: 32px;
  box-sizing: border-box;
  position: relative;
}

.question-item {
  width: calc(100% - 80px);
  box-sizing: border-box;
  margin: 40px auto;
  padding-left: 25px;
}

.exam-top {
  width: calc(100% - 80px);
  box-sizing: border-box;
  height: 80px;
  line-height: 80px;
  background-color: #FFF9F5;
  border-radius: 10px;
  margin: 40px auto;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #B66E3D;
  padding-left: 25px;
  background-image: url(http://feed.youshu.cc/readwith/media/picture/60c032637d3be.png);
  background-repeat: no-repeat;
  background-size: 41px 30px;
  background-position: calc(100% - 5px) 9px;
}

.exam-top span {
  color: #FF6F27;
  font-size: 30px;
}

/* 单选 */
.question-title {
  font-size: 36px;
  color: #30353D;
  font-weight: bold;
  line-height: 80px;
}

.item {
  margin-bottom: 80px;
}

.item-input-cont {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 40px;
}

.label {
  width: 48%;
  font-size: 30px;
  margin-bottom: 50px;
  margin-left: 10px;
  color: #444;
  font-size: 34px;
  line-height: 50px;
}

input[type='radio'] {
  background-color: #FF6F27;
  border-color: #FF6F27;
}

.btn {
  width: calc(100% - 80px);
  height: 104px;
  display: block;
  margin: 0 auto;
  border: none;
  line-height: 104px;
  border-radius: 20px;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 20px;
  cursor: pointer;
}

.wrapper {
  width: 100%;
}

.img_wrapper {
  width: 100%;
  height: 100%;
}

.img_wrapper img {
  width: 100%;
}

.image-box {
  position: relative;
  overflow: hidden;
}

.image-box img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0;
  border: 0;
  -webkit-user-drag: none;
}

.pay-box {
  width: 100%;
  height: 124px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 15px;
  position: fixed;
  z-index: 52;
  left: 0;
  bottom: 0;
  box-shadow: 0 -1px 0 0 #ececec;
}

.pay-box .price-box {
  flex: 4;
  height: 100%;
  display: flex;
  align-items: center;
}

.pay-box .price-box .price {
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FF6F27;
  margin: 0 5px 0 0;
}

.pay-box .price-box .num {
  /* height: 29px; */
  font-size: 48px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FF6B3D;
  margin: 0;
}

.pay-box .pay-btn {
  flex: 4;
  height: 80px;
  text-align: center;
  border-radius: 20px;
  background-color: #FF6F27;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 80px;
  cursor: pointer;
}

.dig-div {
  height: 124px;
  width: 100%;
}

.bottom img {
  width: 100%;
}

.close {
  padding: 30px;
  font-size: 36px;
  text-align: right;
  color: #333;
}

.bottom p {
  font-size: 30px;
  padding: 20px;
  text-align: center;
  color: #666;
}

/*弹框*/

.dig_wrap {
  width: 100%;
  background: #FFFFFF;
  position: relative;
  height: 100%;
  overflow: hidden;
}

.dig_box {
  width: 100%;
  background: #FFFFFF;
  text-align: center;
}

.dig_wrap >>> .mint-popup {
  width: 95%;
  margin: 0 auto;
  height: 700px;
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;


}

.dig_wrap >>> .mint-popup-bottom {
  width: 100%;
  height: 900px;
}

.dig_wrap >>> .mint-cell-title {
  width: 150px;
}

.dig_wrap >>> .mint-cell-wrapper {
  height: 100px;
  border: 1px solid #ededed;
  border-radius: 10px;
  margin: 20px;
}

.dig_wrap >>> .mint-cell-text {
  font-size: 32px;
}

.dig_wrap >>> .mint-button--primary {
  background: #FF6F27;
}

.dig_wrap >>> .mint-field-core {
  font-size: 32px;
  padding-left: 10px;
}

.dig_wrap >>> .mint-button--normal {
  text-align: center;
  padding: 0px;
  font-size: 40px;
  font-weight: bold;
  width: 500px;
  height: 100px;
  border-radius: 50px;
  margin-top: 30px;
}


.company {
  text-align: center;
  font-size: 32px;
  margin: 20px 0;
}

.getCode-btn {
  font-size: 28px;
  margin-right: 5px;
  display: inline-block;
  width: 35%;
  text-align: right;
}

.dig_box {
  padding: 0 30px;
}

.input {
  width: 100%;
  height: 100px;
  line-height: 100px;
  margin-top: 20px;
  border: 4px solid #ccc;
  border-radius: 10px;
  text-indent: 20px

}

.dig-label {
  width: 20%;
  font-size: 30px;
  margin-top: 20px;
  text-align: left;

}

.refereeName-input {
  width: 62%;
  height: 100px;
  line-height: 100px;
  margin-top: 20px;
  border: 4px solid #ccc;
  border-radius: 10px;
  text-indent: 20px

}

input::placeholder {
  color: #999999;
  font-size: 30px;
}

.apply {
  width: 60%;
  height: 120px;
  text-align: center;
  border-radius: 60px;
  background-color: #FF6F27;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 120px;
  font-size: 40px;
  cursor: pointer;
  margin: 0 auto;
}
</style>
<style>
.notice {
  /*font-size: 28px !important;*/
  transform: scale(1.5) !important;
  margin-left: -1.3rem !important;
  z-index: 999999;
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/advertisePage.vue